export const ESSENTIAL_TEXT = {
  title: 'Essential Cookies',
  description:
    'These cookies are necessary for the website to function and cannot be switched off.',
};
